export default {
  allActions: [],
  allGroups: [],
  actionGroupData: {
    _id: null,
    name: null,
  },
  favouriteGroup: {
    _id: null,
    name: null,
    metric: null,
  },
  myActionId: '0',
  myActionsIds: [],
  myActionName: 'todas as ações',
  actionList: [],
  totalActionList: 0,
  schedule: 'now',
  scheduleInfo: {
    time: '00:00',
    formattedDate: null,
  },
  nowStep: 0,
  submitButton: false,
  clientsCount: 0,
  listId: null,
  actionDetails: {},
  testNpsReview: null,
  switchQuestions: false,
  isResubmit: false,
  isEditAction: false,
  action: {
    enableAnonymous: null,
    _id: null,
    name: null,
    companyId: null,
    question: null,
    questionHTML: null,
    type: 'nps-0-10',
    channel: 'email',
    email: {
      subject: null,
      from: null,
      template: {
        id: '1',
        myHTML: `<p>Obrigado por escolher a nossa empresa. <br> </p>
        <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
          questionário que dura apenas 60 segundos.
          <br>
        </p>
        <p>Agradecemos a sua colaboração.<br></p>`,
        scale: 'colors',
        border: '',
        grade: '#606060',
        button: '#7da38b',
        footer: true,
        scaleLayout: 'grades',
        submitButtonValue: null,
        myHTMLEs: `<p>Gracias por elegir nuestra empresa. <br> </p>
        <p>Nos gustaría mejorar su experiencia con nuestros servicios a través de este
          cuestionario que solo dura 60 segundos.
          <br>
        </p>
        <p>Gracias por su cooperación.<br></p>`,
        myHTMLEn: `<p>Thank you for choosing our company. <br> </p>
        <p>We would like to improve your experience with our services through this
          quiz that only lasts 60 seconds.
          <br>
        </p>
        <p>Thank you for your cooperation.<br></p>`,
        enableMyHTMLPt: true,
        enableMyHTMLEn: false,
        enableMyHTMLEs: false,
      },
      emailTemplateCustom: {
        enableHeaderLogo: false,
        headerLogo: null,
        enableBody: false,
        htmlBodyPt: '',
        htmlBodyEn: '',
        htmlBodyEs: '',
        enableFooter: false,
        customHtmlFooterPt: '',
        customHtmlFooterEn: '',
        customHtmlFooterEs: '',
        questionPt: '',
        questionEs: '',
        questionEn: '',
        enableTemplatePt: false,
        enableTemplateEs: false,
        enableTemplateEn: false,
      },
      additionalQuestions: [],
    },
    sms: {
      config: 'link',
      msgLink: 'Responda a nossa pesquisa gratuitamente aqui:',
    },
    reply: {
      detractors: 'Na sua opinião, quais os itens devem ser melhorados?',
      neutral: 'Na sua opinião, o que falta para ganharmos nota máxima?',
      promoters: 'O que te motivou a dar essa nota?',
      languageSupport: {
        detractorsEN: 'In your opinion, which items should be improved?',
        detractorsES: 'En su opinión, ¿qué elementos deberían mejorarse?',
        detractorCheckedPT: true,
        detractorCheckedEN: true,
        detractorCheckedES: true,
        neutralEN: 'In your opinion, what is missing for us to earn top marks?',
        neutralES:
          'En su opinión, ¿qué nos falta para obtener las mejores calificaciones?',
        neutralCheckedPT: true,
        neutralCheckedES: true,
        neutralCheckedEN: true,
        promotersEN: 'What motivated you to give this rating?',
        promotersES: '¿Qué te motivó a dar esta calificación?',
        promoterCheckedPT: true,
        promoterCheckedEN: true,
        promoterCheckedES: true,
      },
    },
    alertRules: {
      id: null,
      title: null,
      expire: 90,
      reminders: 0,
      time: '12:00',
      interval: 0,
      htmlReminder: `<p>Obrigado por escolher a nossa empresa. <br> </p>
      <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
        questionário que dura apenas 60 segundos.
        <br>
      </p>
      <p>Agradecemos a sua colaboração.<br></p>`,
    },
    quarentine: {
      // type: 'none',
      days: '0',
      expirationType: 'company',
      activeSubmit: false,
      typeAnswer: 'none',
      daysAnswer: '0',
      expirationTypeAnswer: 'company',
      activeAnswer: false,
    },
    logo: null,
    useLogo: true,
    uploadedImage: null,
    privacyPolicy: null,
    commentPosition: 'down',
    footerEnabled: false,
    footerContent: null,
    closingMessageEnabled: false,
    automaticAnswerEnabled: false,
    surveyType: 'survey',
    allAnswersRequired: false,
    smsReminder: false,
    multiLanguage: false,
  },
  closingMessage: {
    _id: null,
    dynamic: false,
    default: {
      useLogo: true,
      html: null,
      htmlEn: null,
      htmlEs: null,
    },
    promoters: {
      useLogo: true,
      html: null,
    },
    passives: {
      useLogo: true,
      html: null,
    },
    detractors: {
      useLogo: true,
      html: null,
    },
  },
  autoReply: {
    _id: null,
    typeAnswer: 'immediate',
    promoters: {
      html: '<p>Obrigado por responder nossa pesquisa!</p>',
      sender: '',
      subject: 'Avalie sua experiência com a Indecx',
    },
    passives: {
      html: '<p>Obrigado por responder nossa pesquisa!</p>',
      sender: '',
      subject: 'Avalie sua experiência com a Indecx',
    },
    detractors: {
      html: '<p>Sinto muito por não ter atendido suas expectativas. Obrigado!</p>',
      sender: '',
      subject: 'Avalie sua experiência com a Indecx',
    },
  },
  actionCreated: {},
  ActionNps: 0,
  ActionNpsRound: 0,
  actionWordCloud: [],
  page: 1,
  fromDetails: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/actions/initialState.js